import { useToast } from '@components/index'
import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useOnError } from '@services/utils/onError'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { metersQueryKey } from '../queries/useMeters'

export function useDeleteMeterReading() {
  const toast = useToast()
  const { t } = useTranslation('toast')
  const queryClient = useQueryClient()
  const onError = useOnError()

  async function deleteReading(id: string) {
    await apiClient.delete(SNA_PREFIX + `meter-readings/${id}`)
  }

  return useMutation({
    mutationFn: deleteReading,
    onSuccess: () => {
      toast.success({ message: t('meterReadingDeleted') })
      queryClient.invalidateQueries({ queryKey: metersQueryKey })
    },
    onError
  })
}
